import { BASE_URL, STORAGE_URL } from './envs';

export const STORAGE = STORAGE_URL;
export const API_ENDPOINT = BASE_URL + 'api/';
export const CONTENT_URL = STORAGE + 'contents/';
export const IMAGE_URL = CONTENT_URL + 'Images/';
export const GENERAL_PATH = STORAGE + 'general/';
